<template>
    <v-container class="px-5 my-5">
      <v-row>
        <v-col cols="12">
          <v-card class="rounded-lg">
            <v-card-title
              class="text-h6 grey--text text--darken-3 font-weight-medium pt-8 mx-4"
              style="font-size: 20px !important;"
              >Merge Tags
              <v-spacer />
              <!-- <v-btn
                color="primary"
                class="mx-2 rounded-lg"
                @click="toggleDrawer()"
              >
                <span style="color: #fff;">
                  <v-icon>add</v-icon> {{$t("goals.create_button")}}
                </span>
              </v-btn> -->
            </v-card-title>
            <v-divider />
            <template>
              <v-data-table
                :loading="mergeTagsTable.loading"
                :headers="mergeTagsTable.headers"
                :items="mergeTagsTable.items"
                :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
                :items-per-page="mergeTagsTable.pagination.itemsPerPage"
                :no-data-text="$t('subscriptions_report.no_data')"
                :no-results-text="$t('subscriptions_report.no_data')"
              >
                <!-- SHOWS NO DATA -->
                <template v-slot:no-data>
                  <div class="text-center pa-5 my-5">
                    <v-img
                      :src="require('@/assets/svg/box_empty.svg')"
                      height="150"
                      max-height="150px"
                      aspect-ratio="1"
                      contain
                    />
                    <div class="grey--text">
                      {{ $t("common.no_data") }}
                    </div>
                  </div>
                </template>
  
                <template v-slot:item.actions="{ item }">
                  <v-btn small icon color="primary" @click="editItem(item)">
                    <v-icon small>
                      edit
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-col>
      </v-row>
  
      <!------------------------------------------------->
      <!-- Drawer --------------------------------------->
      <!------------------------------------------------->
  
      <v-dialog v-model="drawer" persistent max-width="600px">
        <v-card style="border-radius: 16px; padding: 20px;">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="toggleDrawer()">
              {{$t("goals.close_button")}}
            </v-btn>
            <v-btn :disabled="disabled" color="primary" @click="save">
              {{$t("goals.save_button")}}
            </v-btn>
          </v-card-actions>
          <v-card-title class="d-flex align-items-center justify-center">
            <span class="text-h7">{{
              update ?  'Update Merge Tag'  : 'Create Merge Tag'
            }}</span>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-divider></v-divider>
          <v-card-text class="mt-8">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                :label="$t('goals.name_label')"
                v-model="name"
                required
                v-validate="'required'"
                data-vv-name="name"
                outlined
                dense
                class="rounded-lg"
              ></v-text-field>
              <v-text-field
                :label="$t('goals.description_label')"
                v-model="description"
                required
                data-vv-name="description"
                outlined
                dense
                class="rounded-lg"
              ></v-text-field>
              <v-autocomplete
                v-model="selectedOrganizations"
                :items="organizations"
                item-value="id"
                item-text="name"
                :label="
                  $t(
                    'notifications.form.inputs.send_methods.specific.organizations'
                  )
                "
                class="rounded-lg"
                multiple
                clearable
                small-chips
                required
                data-vv-name="selectedOrganizations"
                outlined
                dense
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="all"
                        @change="toggleSelectAll()"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Select All</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import organizationMixin from "@/mixins/organization";
  import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
  import BaseToolbar from "@/components/BaseToolbar.vue";
  import { organizationService } from "@/services/organization.service";
  
  export default {
    name: "Merge Tags",
    mixins: [organizationMixin],
    components: {
      BaseToolbar
    },
    data() {
      return {
        valid: false,
        disabled: true,
        mergeTagsTable: {
          loading: false,
          items: [],
          search: null,
          total: 0,
          pagination: {
            sortBy: ["created_at"],
            sortDesc: [true],
            itemsPerPage: 10
          },
          headers: [
            {
              text: "ID",
              align: "center",
              sortable: true,
              value: "id",
              class: "text-no-wrap blue--text text--darken-4"
            },
            {
              text: this.$t("common.name"),
              align: "center",
              sortable: true,
              value: "name",
              class: "text-no-wrap blue--text text--darken-4"
            },
            {
              text: 'Variable',
              align: "center",
              sortable: true,
              value: "variable",
              class: "text-no-wrap blue--text text--darken-4"
            },
            {
              text: this.$t("common.description"),
              align: "center",
              sortable: true,
              value: "description",
              class: "text-no-wrap blue--text text--darken-4"
            },
            {
              text: this.$t("dates.date"),
              align: "center",
              sortable: true,
              value: "created_at",
              class: "text-no-wrap blue--text text--darken-4"
            },
            { text: "", value: "actions", sortable: false }
          ]
        },
        drawer: false,
        organizations: [],
        name: "",
        variable: "",
        description: "",
        selectedOrganizations: [],
        all: false,
        allSnippets: false,
        update: false,
        mergeTagToUpdate: null,
        rules: {
          nameRules: [
            v => !!v || "Name is required",
            v => (v && v.length <= 10) || "Name must be less than 10 characters"
          ],
          descriptionRules: [
            v => !!v || "Description is required",
            v => (v && v.length >= 10) || "Name must be less than 10 characters"
          ],
          snippetsRule: [
            v => !!v || this.$t("notifications.form.rules.organizations.required")
          ]
        }
      };
    },
    async created() {
      await this.getAllOrganizations();
      await this.getMergeTagsData()
    },
    watch: {
      name: {
        async handler() {
          const isValid = await this.$validator.validateAll();
          this.disabled = !isValid;
        }
      },
    },
    computed: {
      ...mapGetters({
        mergeTags: "mergeTags/mergeTags"
      })
    },
    methods: {
      ...mapActions({
        updateMergeTag: "mergeTags/updateMergeTag",
        getMergeTags: "mergeTags/getMergeTags"
      }),
      async getAllOrganizations() {
        try {
          const {
            data: organizations
          } = await organizationService.getAllOrganizations();
  
          this.organizations = organizations;
        } catch (error) {
          console.log(error);
        }
      },

      async getMergeTagsData(){
        this.mergeTagsTable.loading = true;  
       
        await this.getMergeTags();
        this.mergeTagsTable.items = this.mergeTags;
        this.mergeTagsTable.total = this.mergeTags.length
  
        this.mergeTagsTable.loading = false;
      },
      async editItem(mergeTag) {
        this.update = true;
        this.mergeTagToUpdate = mergeTag
  
        const mergeTagToUpdate = JSON.parse(JSON.stringify(mergeTag));
  
        this.name = mergeTagToUpdate.name;
        this.variable = mergeTagToUpdate.variable;
        this.description = mergeTagToUpdate.description;
        this.selectedOrganizations = mergeTagToUpdate.organizations ? mergeTagToUpdate.organizations.ids.map(id => id) : [];
        this.drawer = true;
      },
      toggleDrawer() {
        this.drawer = !this.drawer;
  
        if (!this.drawer) {
          this.name = "";
          this.variable = ""
          this.description = "";
          this.selectedOrganizations = [];
          this.update = false;
        }
      },
      async save() {
        if (this.update) {
          await this.updateMergeTag({
            id: this.mergeTagToUpdate.id,
            name: this.name,
            description: this.description,
            organizations: this.selectedOrganizations,
          });
          await this.getMergeTagsData()
          this.toggleDrawer();
          return;
        }
      
        this.toggleDrawer();
      },
      toggleSelectAll() {
        if (!this.all) {
          this.selectedOrganizations = [];
          return;
        }
        this.selectedOrganizations = [];
        this.organizations.forEach(org =>
          this.selectedOrganizations.push(org.id)
        );
      },
    }
  };
  </script>
  